import React from 'react';
import { Box, Flex } from '@withjoy/joykit';
import { ArrowUp, ArrowDown } from '@withjoy/joykit/icons';
import { useTranslation } from '@shared/core';

type ReorderArrowProps = {
  onUp?: () => void;
  onDown?: () => void;
  disabledUp?: boolean;
  disabledDown?: boolean;
};

export const ReorderArrow = ({ onUp, onDown, disabledUp, disabledDown }: ReorderArrowProps) => {
  const { tq } = useTranslation('VIPCustomComponent');

  return (
    <Flex
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      margin="auto 0 auto auto"
      borderRadius="0.375rem"
      overflow="hidden"
      backgroundColor="transparent"
      _hover={{ backgroundColor: 'mono3' }}
      width="28px"
      height="40px"
      gap="2px"
    >
      <Box
        as="button"
        onClick={e => {
          e.stopPropagation();
          onUp?.();
        }}
        disabled={disabledUp}
        background="none"
        border="none"
        padding="0.25rem"
        width="100%"
        cursor={disabledUp ? 'not-allowed' : 'pointer'}
        _hover={{ backgroundColor: 'mono4' }}
        _active={{ backgroundColor: 'mono5' }}
        aria-label={tq`Move up`}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ArrowUp size="sm" />
      </Box>
      <Box
        as="button"
        onClick={e => {
          e.stopPropagation();
          onDown?.();
        }}
        disabled={disabledDown}
        background="none"
        border="none"
        padding="0.25rem"
        width="100%"
        cursor={disabledDown ? 'not-allowed' : 'pointer'}
        _hover={{ backgroundColor: 'mono4' }}
        _active={{ backgroundColor: 'mono5' }}
        aria-label={tq`Move down`}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <ArrowDown size="sm" />
      </Box>
    </Flex>
  );
};
